import React, { useState } from "react";
import {
  Box, Typography, TableBody, TableCell,
  TableHead, TableRow, Paper, Button, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField
} from "@mui/material";
import PropTypes from "prop-types";
import { SettingsOutlined } from "@mui/icons-material";
import { adminEmbeddedTableBodyMaxHeight, adminEmbeddedTablePaperSx, adminDataTableHeadSx } from "../../utils/adminTableScrollSx";
import AdminTableScrollLayout from "../Shared/AdminTableScrollLayout";

const mockParametri = [
  {
    id: "P01",
    nome: "Soglia Alert Budget",
    valore: "100",
    descrizione: "Importo minimo di budget prima di inviare alert"
  },
  {
    id: "P02",
    nome: "Email Notifiche",
    valore: "admin@wowcheprezzi.it",
    descrizione: "Indirizzo email per ricevere notifiche di sistema"
  }
];

const sectionSx = {
    p: 3,
    borderRadius: "20px",
    border: "1px solid #e2e8f0",
    mb: 3,
};

const SectionTitle = ({ icon, title, description }) => (
    <Box sx={{ mb: { xs: 3, md: 4 }, textAlign: "center" }}>
        <Typography
            variant="h5"
            sx={{ fontWeight: 800, letterSpacing: "-0.02em", color: "#0b3d87", lineHeight: 1.15, display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}
        >
            {icon} {title}
        </Typography>
        {description && (
            <Typography variant="body2" sx={{ mt: 0.75, color: "#64748b", fontWeight: 500 }}>
                {description}
            </Typography>
        )}
        <Box
            sx={{
                mt: 1.5,
                mx: "auto",
                width: 56,
                height: 4,
                borderRadius: 999,
                background: "linear-gradient(90deg, #0b3d87 0%, #345ea3 100%)",
            }}
        />
    </Box>
);

SectionTitle.propTypes = {
    icon: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
};

const ParametriSettings = () => {
  const [parametri, setParametri] = useState(mockParametri);
  const [selected, setSelected] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [valoreEdit, setValoreEdit] = useState("");

  const handleOpen = (param) => {
    setSelected(param);
    setValoreEdit(param.valore);
    setModalOpen(true);
  };

  const handleSalva = () => {
    const updated = parametri.map(p =>
      p.id === selected.id ? { ...p, valore: valoreEdit } : p
    );
    setParametri(updated);
    setModalOpen(false);
  };

  return (
    <Box>
      <Paper elevation={3} sx={sectionSx}>
        <SectionTitle 
          icon={<SettingsOutlined />} 
          title="Parametri Generali" 
          description="Gestisci le impostazioni globali e i valori di configurazione."
        />
        <Paper sx={adminEmbeddedTablePaperSx}>
        <AdminTableScrollLayout
          bodyMaxHeight={adminEmbeddedTableBodyMaxHeight}
          head={(
            <TableHead sx={adminDataTableHeadSx}>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>Valore</TableCell>
                <TableCell>Descrizione</TableCell>
                <TableCell>Azioni</TableCell>
              </TableRow>
            </TableHead>
          )}
          body={(
            <TableBody>
              {parametri.map((param, i) => (
                <TableRow key={param.id} sx={{ backgroundColor: i % 2 === 0 ? "#fff" : "#f5f7fa" }}>
                  <TableCell>{param.nome}</TableCell>
                  <TableCell>{param.valore}</TableCell>
                  <TableCell>{param.descrizione}</TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      sx={{ color: "#0b3d87", fontWeight: "bold" }}
                      onClick={() => handleOpen(param)}
                    >
                      MODIFICA
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        />
        </Paper>
      </Paper>

      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} fullWidth>
        <DialogTitle>Modifica Parametro</DialogTitle>
        <DialogContent dividers>
          <Typography sx={{ mb: 2 }}><strong>{selected?.nome}</strong></Typography>
          <TextField
            label="Valore"
            fullWidth
            value={valoreEdit}
            onChange={(e) => setValoreEdit(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)}>Annulla</Button>
          <Button variant="contained" onClick={handleSalva}>
            Salva
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ParametriSettings;
 